<section class="dashboard-recent-orders__section">
	<div class="panel__header h4" data-cy="dashboard-recent-orders__header">{{ 'dashboard.recent_orders_header' | locale: merchantLocaleSuffix }}</div>
	<div class="panel__wrapper">
		<div class="panel__title h5">Example Membership Product</div>
		<div class="panel__info-row">
			<div class="info-row__column">
				<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__order-id-label">{{ 'dashboard.order_id' | locale: merchantLocaleSuffix }}</div>
				<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__order-id-value">987654</div>
			</div>
			<div class="info-row__column">
				<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__purchase-date-label">{{ 'dashboard.purchase_date' | locale: merchantLocaleSuffix }}</div>
				<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__purchase-date-value">Jan 1, 2025</div>
			</div>
			<div class="info-row__grouped">
				<div class="info-row__column">
					<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__total-label">{{ 'dashboard.total' | locale: merchantLocaleSuffix }}</div>
					<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__total-value">$123.99</div>
				</div>
				<div class="info-row__column">
					<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__quantity-label">{{ 'dashboard.quantity' | locale: merchantLocaleSuffix }}</div>
					<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__quantity-value">9</div>
				</div>
			</div>
		</div>
		<div class="panel__next-payment mat-body-2" data-cy="dashboard-recent-orders__next-payment">
			<img class="next-payment__info-icon" src="/assets/icons/info-icon.svg" alt="info-icon" /> <div class="next-payment__localized" [innerHTML]="dashboardLocalization.generateLocalizedUpcomingPaymentString(
				'123.01',
				'VISA',
				'1234',
				'1/1/2025',
				'999.99'
			)"></div>
		</div>
	</div>

	<div class="panel__wrapper">
		<div class="panel__title h5">Another Example Product</div>
		<div class="panel__info-row">
			<div class="info-row__column">
				<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__order-id-label">{{ 'dashboard.order_id' | locale: merchantLocaleSuffix }}</div>
				<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__order-id-value">987654</div>
			</div>
			<div class="info-row__column">
				<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__purchase-date-label">{{ 'dashboard.purchase_date' | locale: merchantLocaleSuffix }}</div>
				<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__purchase-date-value">Jan 1, 2025</div>
			</div>
			<div class="info-row__grouped">
				<div class="info-row__column">
					<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__total-label">{{ 'dashboard.total' | locale: merchantLocaleSuffix }}</div>
					<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__total-value">$123.99</div>
				</div>
				<div class="info-row__column">
					<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__quantity-label">{{ 'dashboard.quantity' | locale: merchantLocaleSuffix }}</div>
					<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__quantity-value">9</div>
				</div>
			</div>
		</div>
	</div>

	<div class="panel__wrapper">
		<div class="panel__title h5">Another Example Product</div>
		<div class="panel__info-row">
			<div class="info-row__column">
				<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__order-id-label">{{ 'dashboard.order_id' | locale: merchantLocaleSuffix }}</div>
				<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__order-id-value">987654</div>
			</div>
			<div class="info-row__column">
				<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__purchase-date-label">{{ 'dashboard.purchase_date' | locale: merchantLocaleSuffix }}</div>
				<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__purchase-date-value">Jan 1, 2025</div>
			</div>
			<div class="info-row__grouped">
				<div class="info-row__column">
					<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__total-label">{{ 'dashboard.total' | locale: merchantLocaleSuffix }}</div>
					<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__total-value">$123.99</div>
				</div>
				<div class="info-row__column">
					<div class="info-row__label mat-subtitle-2" data-cy="dashboard-recent-orders__quantity-label">{{ 'dashboard.quantity' | locale: merchantLocaleSuffix }}</div>
					<div class="info-row__value mat-subtitle-1" data-cy="dashboard-recent-orders__quantity-value">9</div>
				</div>
			</div>
		</div>
	</div>
</section>
